import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CommonModule, JsonPipe } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { ImageUploadPublic } from '../../../../../globalTypes/image.types';
import { sortByKey } from '../../../helper/general';
import { Logger } from '../../../helper/logger';
import { Store } from '@ngrx/store';
import { ListingsPageActions } from '../../../store/listings.store';
import { ListingPublic, ListingVariationPublic } from '../../../../../globalTypes/listings.types';
import { LocationPublic } from '../../../../../globalTypes/account.types';
import { MatButtonModule } from "@angular/material/button";
import { SearchListingPopupData, SearchListingPopupDialog } from '../../../pages/listing/search.listing.popup.dialog';
import { MatDialog } from '@angular/material/dialog';
import { lastValueFrom, take } from 'rxjs';
import { addUserWatchListing, removeUserWatchListing } from '@dataconnect/account';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AUTHORIZED_ACCOUNT_LABEL } from '../../../../../globalTypes/account.types';
import { ListingService } from '../../../services/listing.service';
import { MustLoginSnackComponent } from './must-login.snack';
import { DIGITAL_PRODUCT_LABEL } from '../../../../../globalTypes/configs';
const log = new Logger('ListingsCardComponent');

// [ ] - TEST THIS handle no images
@Component({
  selector: 'msh-listings-card',
  standalone: true,
  imports: [CommonModule, RouterModule, MatIconModule, MatButtonModule],
  template: `
    <div
      class="w-full max-w-xs cursor-pointer select-none"
      (click)="popup($event)"
      >
      <!-- Image Carousel -->
      <div
        class="relative border border-gray-300 rounded overflow-hidden"
        [class.opacity-50]="myListing && isDeleted"
        >
        <div class="relative image-container">
          <div class="absolute w-full min-h-[110%] min-w-[110%] z-0 -top-3 -left-3" [style]="'background:#fff '+ (imageUrls && imageUrls.length > 0 && imageUrls[currentImage] ? 'url('+imageUrls[currentImage].image.url+')' : 'url(ListingPlaceHolder.png)') + ' center/cover no-repeat; filter: blur(4px);' ">test</div>
          @if(imageUrls && imageUrls.length > 0 && imageUrls[currentImage]; as image){
          <img
            [src]="image ? image.image.url : 'ListingPlaceHolder.png'"
            [alt]="name"
            class="w-full relative z-[1] h-[200px] sm:h-[200px] object-contain"
            />
          }
          <!-- Prev / Next buttons -->
          @if(imageUrls && imageUrls.length > 1){
            <div
              class="absolute z-[2] cursor-pointer rounded-e-md left-0 top-1/2 -translate-y-1/2 bg-black bg-opacity-40 text-white px-2 py-1"
              (click)="prevImage($event)"
              >
              ‹
            </div>
          }
          @if(imageUrls.length > 1){
            <div
              class="absolute z-[2] cursor-pointer rounded-tl-md rounded-bl-md right-0 top-1/2 -translate-y-1/2 bg-black bg-opacity-40 text-white px-2 py-1"
              (click)="nextImage($event)"
              >
              ›
            </div>
          }
        </div>
        @if(!isPreviewOnly){
          <!-- Heart icon -->
          @if(!myListing && userId){
            <mat-icon (click)="favoriteIt($event)" class="absolute z-[3] bottom-2 right-2 text-orange-500 hover:opacity-100 " [style]=" favorited ? 'filter: drop-shadow(0 0 8px #ff6600)' : ''" [class.opacity-30]="!favorited" > favorite </mat-icon>
          }
      
          <!-- Edit icon -->
          @if(myListing){
            <mat-icon  class="absolute z-[3] top-2 right-2 text-orange-500" > edit </mat-icon>
          }
        }
      </div>
    
      <!-- Details Section -->
      <div class="mt-2">
        <!-- Price and Stock -->
        <div class="flex justify-between items-center">
          <span class="font-bold text-lg">{{
            priceInCents / 100 | currency
          }}</span>
          @if(listing.statusId === 'pending'){
            <span class=" text-orange-400 font-bold">PENDING</span>
          }@else {
            <span class="text-copy/75 text-sm">
              @if(listing && listing.category && !listing.category.isDigital){ {{ inStock }} in stock} @else { Available }
            </span>
          }
        </div>
    
        <!-- Name -->
        <div class="text-base font-medium hover:text-orange-400 cursor-pointer "
        (click)="navigate($event)">{{ name }}</div>
    
        <!-- Location -->
        <div class="text-sm mt-1 flex justify-between">
          @if (!myListing || isPreviewOnly) {
            <div>
              @if(locations[listing.locationId]; as location){
                <div  (click)="viewListingLocationProfile($event)" class=" cursor-pointer transition-colors hover:text-orange-500">
                  @if(location.verified){ 
                    <div class="relative">
                      <img class=" absolute opacity-75 -top-2 -left-6 w-8 !h-8" src="certified_badge.png" [alt]="AUTHORIZED_ACCOUNT_LABEL" />
                    </div> 
                    {{verifiedLocationNoun + ' - ' }}
                  }@else{ 
                    {{location.owner.displayName + ' - ' }} 
                  }
                  {{ location ? location.name : '' }}
                </div>
              }
            @if(locations[listing.locationId] && locations[listing.locationId].locationAnswers_on_location; as answers){
              @for(answer of answers; track answer.id){
                @if(answer.question && answer.question.displayOnListing){
                  - {{answer.question.displayLabel}} {{answer.answerText || answer.answerValues.join(', ')}}
                }
              }
            }
            @if(isPreviewOnly && !listing.category.isDigital){
              <div class=" text-sm mt-4">Dimensions: {{listing.length}} x {{listing.width}} x {{listing.height}} {{listing.distanceUnit}}</div>
              <div class=" text-sm">Weight: {{listing.weight}} {{listing.weightUnit}} 
                @if(listing.shippingCompressionRate ){ 
                  <div class='text-xs'>(Shipping Compression Rate: {{listing.shippingCompressionRate}})</div>
                }
              </div>
            }
            </div>
          } @else {
            <span class="text-orange-500" (click)="navigate($event)">
              Edit my
              @if (isDeleted) {
                <b class=" uppercase">deleted</b>
              }
                listing
              
            </span>
          }
        </div>
    
        <!-- Extra Details -->
        @if (details && details.length) {
          <ul class="mt-1 text-sm text-gray-600 list-disc pl-4">
            @for (detail of details; track detail) {
              <li>{{ detail }}</li>
            }
          </ul>
        }
      </div>
    </div>
    `,
  styles: [
    `
      @media (max-width: 640px) {
        img.object-contain {
          height: 200px !important;
        }
      }
      .image-container::before {
        content: "";
        top: -10px;
        left: -10px;
        right: -10px;
        bottom: -10px;
        background-size: cover;
        background-position: center;
        filter: blur(20px); 
        z-index: -1;
        min-height: 10px;
      }
    `,
  ],
})
export class ListingsCardComponent implements OnInit, OnChanges {
  @Input() isPreviewOnly = false;
  @Input() userId?: string
  @Input() listing!: ListingPublic;
  @Input() verifiedLocationNoun?: string
  @Input() locationId!: string;
  @Input() locations!: {[locationId: string]: LocationPublic}
  // @Output() onAddedToCart: EventEmitter<ListingVariationPublic> = new EventEmitter();
  AUTHORIZED_ACCOUNT_LABEL = AUTHORIZED_ACCOUNT_LABEL;
  DIGITAL_PRODUCT_LABEL = DIGITAL_PRODUCT_LABEL;
  imageUrls: {
    sortOrder: number;
    image: ImageUploadPublic;
  }[] = [];
  favorited = false;
  inStock = 0;
  priceInCents = 0;
  name = '';
  details: string[] = [];
  myListing = false;
  isDeleted = false;

  currentImage = 0;

  constructor(
    private router: Router,
    private listingService: ListingService,
    private store: Store,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
  ) {}
  ngOnInit(): void {
  }
  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if (changes['listing']) {
      this.imageUrls = JSON.parse(JSON.stringify(this.listing.listingImages_on_listing))
      if(this.imageUrls) this.imageUrls.sort(sortByKey("sortOrder"));
      this.inStock = this.listing.listingVariations_on_listing.reduce((a,c)=>{ a += c.quantity || 0; return a}, 0) || 0
      if(this.listing.category?.isDigital){
        this.inStock = 1;
      }
      this.favorited = this.userId && this.listing.userWatchListings_on_listing.some(uwl=>uwl.userId === this.userId) || false
      this.priceInCents = this.listing.lowestPrice || this.listing.listingVariations_on_listing[0]?.priceInCents || 0
      this.name = this.listing.name
      //TODO: add listing questions that are isDisplayable
      this.details = []
      const shippingCostText = this.listingService.getShippingCostText(this.listing);
      if (shippingCostText) this.details.push(shippingCostText);
      this.myListing = this.listing.locationId == this.locationId
      this.isDeleted = this.listing.statusId == 'removed'
    }
  }

  nextImage(event: Event) {
    event.stopPropagation();
    this.currentImage = (this.currentImage + 1) % this.imageUrls.length;
  }

  prevImage(event: Event) {
    event.stopPropagation();
    this.currentImage =
      (this.currentImage - 1 + this.imageUrls.length) % this.imageUrls.length;
  }

  viewListingLocationProfile(event: Event){
    event.stopPropagation();
    if(this.isPreviewOnly) return;
    this.router.navigate(['profile', 'listings', this.listing.locationId]);
  }

  async favoriteIt(event: Event){
    // TODO; FIX favorite UP PROPERLY
    event.stopPropagation();
    this.favorited = !this.favorited;
    if(this.isPreviewOnly) return;
    try {
      if(this.favorited){
        await addUserWatchListing({listingId: this.listing.id})
      } else {
        await removeUserWatchListing({listingId: this.listing.id})
      }
    } catch (error) {
      log.error({error})
      this.snackBar.open("Error saving this to your watch list")
      this.favorited = !this.favorited;
    }
  }

  async popup(event: Event){
    if(this.isPreviewOnly) return;
    if ((event.target as HTMLElement).tagName === 'BUTTON') return;
    const data: SearchListingPopupData = { listing: this.listing }
    log.log({thisListingData: data})
    const dialog = this.dialog.open(SearchListingPopupDialog, {data});
    await lastValueFrom(dialog.afterClosed().pipe(take(1)))
  }

  navigate(event: Event) {
    if(this.isPreviewOnly) return;
    event.stopPropagation();
    this.store.dispatch(ListingsPageActions.progressListing({listing: this.listing}))
    if (this.myListing) {
      this.router.navigate(['manage-listing', 'details', this.listing.id]);
    } else {
      this.router.navigate(['listing', 'details', this.listing.id]);
    }
  }
}
